<template>
  <div>
    <Nav></Nav>

    <!-- Content docks -->
    <mdb-container fluid class="py-2">
      <mdb-container class="mt-5 mb-5 content podcasts">
        <mdb-row class="mb-4">
          <mdb-col md="2">
            <router-link to="/podcasts">
              <mdb-icon icon="arrow-left" />&nbsp;Back to all episodes
            </router-link>
          </mdb-col>
          <mdb-col md="8">
            <div class="top-info-text mb-2">EPISODE #{{docdata.episodeno}}</div>
            <h1>{{docdata.name}}</h1>

            <!-- <iframe
              src="https://anchor.fm/szymon-kubisa/embed/episodes/Episode-2-e4tcei"
              height="202px"
              width="100%"
              frameborder="0"
              scrolling="no"
            ></iframe>-->

            <span v-html="docdata.code"></span>

            <div class="mb-4">{{docdata.excerpt}}</div>

            <div v-html="docdata.timestampedshownotes"></div>
          </mdb-col>
          <mdb-col md="2"></mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-container>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import { store } from "../store";
import firebase from "firebase/app";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon
} from "mdbvue";

export default {
  name: "Podcast",
  data() {
    return {
      podcastid: "",
      docdata: {}
    };
  },
  methods: {
    mthFillPodcastData() {
      //ref
      let docref = firebase
        .firestore()
        .collection("podcasts")
        .doc(this.podcastid);

      //snap
      var docpodcast = docref
        .get()
        .then(doc => {
          if (doc.data() === undefined) {
            //console.log("%cmthFillPodcastData: 156 data empty", "color:red");
          } else {
            this.docdata = doc.data();
          }
        })
        .catch(err => {
          //console.log("%cmthFillPodcastData: 162 error : " + err, "color:red");
        });
      //end of snap
    }
  },
  created() {
    this.podcastid = this.$router.currentRoute.params.podcastid;
    this.podcastdata = this.mthFillPodcastData();
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon
  }
};
</script>

<style>
</style>
